import request from '@/utils/request'
import { calendarSsoUrl} from '@/config/net.config.js'
  import qs from 'qs'

//学期
export function getAllSemesters(jwtoken) {
    return request({
      url: calendarSsoUrl+'/api/mobile/jwxt/stuInfo/getAllSemesters',
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:jwtoken
    })
  }
//学期日历
  export function getCurrCalendar(id,jwtoken) {    
    return request({
      url: calendarSsoUrl+'/api/mobile/jwxt/calendar/getCurrCalendar?semesterId='+id,
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:jwtoken
    })
  } 

  //学生课表
  export function getSchedule(data,jwtoken) {    
    return request({
       url: calendarSsoUrl+'/api/mobile/jwxt/schedule/getSchedule?'+qs.stringify(data),
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:jwtoken
    })
  } 
  //老师课表
  export function getTeacherSchedule(data,jwtoken) {    
    return request({
         
      url: calendarSsoUrl+'/api/mobile/jwxt/teacher/getCourseSchedulingDataInfo?'+qs.stringify(data),
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:jwtoken
    })
  } 
   //学生信息
   export function getStuInfo(xhid,jwtoken) {    
    return request({
      url: calendarSsoUrl+'/api/mobile/jwxt/stuInfo/getStuInfo/'+xhid,
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:jwtoken
    })
  } 

    //教师信息
    export function getTeacherInfoList(xhid,jwtoken) {    
      return request({
        url: calendarSsoUrl+'/api/mobile/jwxt/teacher/getTeacherInfoList/?teacherCode='+xhid,
        head: 'application/json;charset=UTF-8',
        method: 'get',
        token:jwtoken
      })
    } 